import React, { Component } from "react";
import { Button, Form } from "react-bootstrap";
import Select from 'react-select';
import imgCamelLogo from '../../assets/images/main-logo-white.png';
import "./InviteUserForm.scss";

class InviteUserForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      name: '',
      role: '',
      error: null
    }
  }

  onChangeRole = (value) => {
    this.setState({ role: value.value })
  }

  onSubmit = (e) => {
    e.preventDefault();

    const { email, name, role } = this.state
    const emailRule = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (name === '') {
      this.setState({ error: 'Please input username' });
      return;
    }

    if (email === '') {
      this.setState({ error: 'Please input email.' });
      return;
    } else if (!emailRule.test(email)) {
      this.setState({ error: 'Please input correct email.' });
      return;
    }

    if (!role || role === '') {
      this.setState({ error: 'Please select user role.' });
      return;
    }

    this.props.inviteUser({
      name,
      email,
      role
    });

    this.props.onClose();
  }

  render() {
    const { role } = this.state;

    return (
      <div className="invite-user-form">
        <div className="form-header">
          <img src={imgCamelLogo} alt="logo" />
        </div>
        <div className="p-4">
          <h3>Invite a new user</h3>
          <Form onSubmit={this.onSubmit}>
            <Form.Group controlId="formBasicName" className="mb-4">
              <Form.Control type="text" placeholder="Enter new user name" onChange={e => this.setState({ name: e.target.value })} />
            </Form.Group>
            <Form.Group controlId="formBasicEmail" className="mb-4">
              <Form.Control type="text" placeholder="Enter email" onChange={e => this.setState({ email: e.target.value })} />
            </Form.Group>
            <Select
              options={[
                { value: 'admin', label: 'Admin' },
                { value: 'user', label: 'User' }
              ]}
              placeholder="Select Role"
              onChange={this.onChangeRole}
              size={16}
              value={{ value: role, label: role }}
            />
            {this.state.error && <div className="mt-2" style={{ color: 'red' }}>{this.state.error}</div>}
            <div className="actions-box mt-4">
              <Button variant="outline-danger" className="ml-2" size="sm" onClick={this.props.onClose}>CANCEL</Button>
              <Button type="submit" variant="outline-danger" className="ml-2" size="sm">SEND INVITATION</Button>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default InviteUserForm;
